import { Link } from "react-router";
import AcademicWiz from "../common/academicWiz"
import { all_routes } from "../../../router/all_routes";
import { AcademicCommonProps, BreadCrumb, Course } from "../../../../types/dataModel";
import useFetch from "../../../../hooks/useFetch";
import { useEffect, useState } from "react";
import { API } from "../../../../common/Constants";
import { getAPIHeaders } from "../../../../common/Utils";
import PreLoader from "../../../../core/common/preLoader";
import { MsgBoxProps } from "../common/acadmicWizModal";
import DeleteModal from "../../../../core/modals/deleteModal";
import { useAccess } from "../../../../hooks/accessContext";

 const breadCrums: BreadCrumb[] = [
    {
      title: "Acdemics",
      link : ""
    },
    {
      title: "Course",
      link : all_routes.courses
    },
    {
      title: "Course Subjects",
      link : ""
    },
 ]
  
  
  const heading ="Course List"
  const mainAddBtnTxt = "Add Subject To Course"
  
  function renderRowStartTag(prop:any) {
    return (<span className="badge bg-transparent-dark text-dark rounded-pill ms-2">
      {prop?.code}
    </span>)
  }
  
  function renderTitleTags(props: any) {
    return (
      <>
        <span className="badge bg-light rounded-pill ms-2">
          Code: {props?.code}
        </span>
        <span className="badge bg-light rounded-pill ms-2">
          Subjects: {props?.items?.length}
        </span>

      </>
    )
  }

  function parseToDropDownMenu (data:any[]) {
    let menu: any[] = []

    data?.forEach((item)=>{
      if(item.status !== "INACTIVE"){
        menu.push({
          value:  item.code,
          label: item.title
        })
      }
    })
    return menu;
  }

const CourseWiz = () => {
    const {hasAcademicMgntDelete} = useAccess()
    const { isLoading, error, callFetch } = useFetch();
    const [subject, setSubject] = useState<any>([]);
    const [courses, setCourses] = useState<any>([]);
    const [msgBoxProps, setMsgBoxProp] = useState<MsgBoxProps>()
    const [deleteItem, setDeleteItem] = useState<any>({
        course:undefined, 
        subject:undefined,
        message: undefined,
    })

    useEffect(() => {
        fetchCourses()
        fetchSubjects()
    }, []);
    
    const fetchCourses = () => {
        callFetch(API.COURSE,
          'GET',
          getAPIHeaders(),
          null,
          null
      ).then((res:any)=>{
        if(res){
            setCourses(res)
        }
      }).catch((err) => {});;
    }

    const fetchSubjects = () => {
        callFetch(API.SUBJECT_SEARCH,
          'GET',
          getAPIHeaders(),
          null,
          null
      ).then((res:any)=>{
        if(res){
            setSubject(res)
        }
      }).catch((err) => {});
    }

    const saveCourse = (valPrnt:any, valChild:any) => {
      if(!valPrnt){
        setMsgBoxProp({error:true, message:"Please select a course", success: false})
      } else if (!valChild){
        setMsgBoxProp({error:true, message:"Please select a subject", success: false})
      } else {
        const selectedCourse = courses.find((course: Course) => course.code === valPrnt);
        const isDuplicate = selectedCourse?.subjects?.some((subject: any) => subject.code === valChild);

        if (isDuplicate) {
            setMsgBoxProp({
              error: true, 
              message: "This subject is already added to the selected course", 
              success: false
            });
            return;
        }

        callFetch(API.COURSE_SUBJECT,
            'POST',
            getAPIHeaders(),
            null,
            {
              courseCode: valPrnt,
              subjectCode: valChild
            }
        ).then(()=>{
          setMsgBoxProp({error:false, message:"Course added successfully", success: true})
          fetchCourses()
        }).catch((err) => {
          setMsgBoxProp({error:true, message:"Failed to add course", success: false})
        });
      }
    }

    const removeSubject = (courseCode: string, subjectCode:string) => {
      callFetch(API.COURSE_SUBJECT,
        'DELETE',
        getAPIHeaders(),
        null,
        {
          courseCode: courseCode,
          subjectCode: subjectCode 
        }
    ).then(()=>{
      setMsgBoxProp({error:false, message:"Course removed successfully", success: true})
      fetchCourses()
    }).catch((err) => {
      setMsgBoxProp({error:true, message:"Failed to remove course", success: false})
    });
  }

    useEffect(() => {
      if(error){
        if(error.response?.data){
          setMsgBoxProp({message: error.response?.data, error:true})
        } else{
          setMsgBoxProp({message:'Something went wrong please try again later.', error: true})
        }
      }
  }, [error]);

  const renderRowEndTag = (prnt:any, child: any) => {
    return (
      <div className="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
        <span className="badge badge-info me-3">
          {child.type}
        </span>
        {/* <span className="badge badge-soft-primary d-flex align-items-center me-3">
          <i className="fas fa-circle fs-6 me-1" />
          Live
        </span> */}
        {/* <span className="badge badge-soft-secondary d-flex align-items-center me-3">
          <i className="fas fa-circle fs-6 me-1" />
          Stale
        </span> */}
        <div className="dropdown ms-2">
          {  
            hasAcademicMgntDelete() && prnt.status !== 'INACTIVE'?
            <>
              <Link
                to="#"
                className="d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i className="ti ti-dots-vertical" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                    data-bs-toggle="modal" data-inert={true}
                    data-bs-target="#delete_modal"
                    onClick={()=>setDeleteItem({
                        course: prnt.code, 
                        subject: child.code,
                        message: `Are you sure you want to remove subject ${child.code} from course ${prnt.code}? This action is irreversible and cannot be undone.`
                      })}
                    >
                    <i className="ti ti-trash me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </>
            :
            <></>
            }
        </div>
      </div>
    )
  }
    return (
        <>
        <PreLoader showLoader={isLoading} />
        <AcademicWiz
            pageHeading="Manage Course Subjects"
            heading={heading} 
            headingTag={""} 
            renderRowStartTag={renderRowStartTag} 
            renderRowEndTag={renderRowEndTag} 
            renderTitleTags={renderTitleTags} 
            addButtonTxt={mainAddBtnTxt} 
            data={parseToCommonProps(courses)}
            breadCrumbs={breadCrums} 
            formHeading="Add Subject to Course"
            formDropDownParent={{
                dropDownItems: parseToDropDownMenu(courses),
                dropDownLable: "Select Course",
                dropDownDefault:undefined
              }}
            formDropDownChild={{
                dropDownItems: parseToDropDownMenu(subject),
                dropDownLable: "Select Subject",
                dropDownDefault:undefined
              }} 
            onSave={saveCourse}
            msgBoxProps={msgBoxProps}
            />
          <DeleteModal 
            heading="Confirm Delete"
            message={deleteItem.message}
            onDelete={()=>removeSubject(deleteItem?.course, deleteItem?.subject)}
          />
        </>

    )
}


function parseToCommonProps (data:Course[]) {
  let acedemicProps : AcademicCommonProps[] = []
  if(acedemicProps){
    data.forEach((course)=>{
        let prop:AcademicCommonProps = {
          ...course,
          items:[]
        }

        course?.subjects?.forEach((sub)=>{
          prop.items?.push({
            ...sub
          })
        })

        acedemicProps.push(prop)
    })
  }
  return acedemicProps
}

export default CourseWiz